import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/ShubhPaisa.svg";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram,
  FaXTwitter,
} from "react-icons/fa6";

export default function Footer() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  return (
    <footer className="mt-5">
      <div
        style={{
          backgroundColor: "#2E4463",
          color: "#fff",
          padding: isMobile ? "16px 0" : "20px 0",
        }}
      >
        <div className="row d-flex justify-content-center m-0">
          <div className="col-md-8 p-0 col-12">
            <div className="container p-3 text-center text-md-start">
              <h4
                className="fw-semibold mb-4 text-center"
                style={{
                  fontSize: isMobile
                    ? "18px"
                    : isTablet
                    ? "20px"
                    : "22px",
                }}
              >
                Services
              </h4>

              <div className="row justify-content-center">
                {/* LEFT */}
                <div className="col-12 col-md-6 col-lg-8 loan-col">
                  <Link
                    to="/personal-loan"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Personal Loan
                    </h6>
                  </Link>

                  <Link
                    to="/housing-loan"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Housing Loan
                    </h6>
                  </Link>

                  <Link
                    to="/loan-against-property"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Loan Against Property
                    </h6>
                  </Link>
                </div>

                {/* RIGHT*/}
                <div className="col-12 col-md-6 col-lg-4 loan-col">
                  <Link
                    to="/business-loan"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Business Loan
                    </h6>
                  </Link>

                  <Link
                    to="/gold-loan"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Gold Loan
                    </h6>
                  </Link>

                  <Link
                    to="/vehicle-loan"
                    className="text-decoration-none text-white"
                  >
                    <h6
                      className="pb-2 fw-light"
                      style={{ fontSize: isMobile ? "14px" : "15px" }}
                    >
                      Vehicle Loan
                    </h6>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Middle Section */}
      <div
        style={{
          backgroundColor: "#E9EBF7",
          color: "#333",
          padding: isMobile ? "24px 0" : "40px 0",
        }}
      >
        <div className="row d-flex justify-content-center m-0">
          <div className="col-md-10 col-12">
            <div className="row align-items-start">
              {/* Logo */}
              <div className="col-12 col-md-4 mb-4 text-center text-md-start">
                <Link to="/">
                  <img
                    src={logo}
                    alt="ShubhPaisa Logo"
                    style={{
                      width: isMobile ? "150px" : "180px",
                      maxWidth: "70%",
                    }}
                    className="mb-3"
                  />
                </Link>

                <p
                  className="text-muted mb-0 mx-3 mx-md-0 responsive-text"
                  style={{ fontSize: isMobile ? "13px" : "14px" }}
                >
                  Our goal is to provide easy-to-use, transparent financial
                  products that cater to the rapidly evolving financial needs of
                  India.
                </p>
              </div>

              {/* Company Links */}
              <div className="col-12 col-md-2 mb-4 text-center text-md-start">
                <h6
                  className="fw-bold mb-3"
                  style={{ fontSize: isMobile ? "14px" : "15px" }}
                >
                  Company
                </h6>
                <ul className="list-unstyled small d-flex flex-row flex-md-column justify-content-center justify-content-md-start gap-3 gap-md-2">
                  <li style={{ fontSize: isMobile ? "13px" : "1rem" }}>
                    <Link
                      to="/about-us"
                      className="text-decoration-underline text-dark"
                    >
                      About Us
                    </Link>
                  </li>
                  <li style={{ fontSize: isMobile ? "13px" : "1rem" }}>
                    <Link
                      to="/careers"
                      className="text-decoration-underline text-dark"
                    >
                      Careers
                    </Link>
                  </li>
                  <li style={{ fontSize: isMobile ? "13px" : "1rem" }}>
                    <Link
                      to="/all-blogs"
                      className="text-decoration-underline text-dark"
                    >
                      Blog
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Location Links */}
              <div className="col-12 col-md-2 mb-4 text-center text-md-start">
                <h6
                  className="fw-bold mb-3"
                  style={{ fontSize: isMobile ? "14px" : "15px" }}
                >
                  Location
                </h6>
                <ul className="list-unstyled small d-flex flex-row flex-md-column justify-content-center justify-content-md-start gap-3 gap-md-2">
                  <li style={{ fontSize: isMobile ? "13px" : "1rem" }}>
                    <Link
                      to="/contact"
                      className="text-decoration-underline text-dark"
                    >
                      Contact Us
                    </Link>
                  </li>
                  <li style={{ fontSize: isMobile ? "13px" : "1rem" }}>
                    <Link
                      to="/locate"
                      className="text-decoration-underline text-dark"
                    >
                      Locate us
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Social Links */}
              <div className="col-12 col-md-4 mb-4 text-center text-md-start">
                <h6
                  className="fw-bold mb-3"
                  style={{ fontSize: isMobile ? "14px" : "15px" }}
                >
                  Social Links
                </h6>

                <div className="d-flex align-items-center gap-3 mb-2 justify-content-center justify-content-md-start">
                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaFacebookF className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaLinkedinIn className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaInstagram className="text-white" size={18} />
                  </div>

                  <div
                    className="bg-primary rounded-circle d-flex justify-content-center align-items-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <FaXTwitter className="text-white" size={18} />
                  </div>
                </div>

                <p
                  className="small mb-1"
                  style={{ fontSize: isMobile ? "13px" : "14px" }}
                >
                  Support: +91 9898800754
                </p>
                <p
                  className="small mb-0 mx-3 mx-md-0"
                  style={{ fontSize: isMobile ? "13px" : "14px" }}
                >
                  Address: Ithum Tower, Tower-B, 218, <br /> Second Floor,
                  Sector 62 Noida-201309
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div
        style={{
          backgroundColor: "#F7F7F7",
          padding: isMobile ? "10px 0" : "15px 0",
          fontSize: isMobile ? "12px" : "14px",
        }}
      >
        <div className="row d-flex justify-content-center m-0">
          <div className="col-md-9 col-12">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
              <p className="mb-2 mb-md-0 text-muted">
                © 2025 ShubhPaisa Limited
              </p>
              <div>
                <Link to="/privacy-policy" className="text-muted me-3">
                  Privacy Policy
                </Link>
                <Link to="/terms-condition" className="text-muted">
                  Terms & Conditions
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
